import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { CasInvoiceApi } from "../../services";

export const useInvoiceUrl = (orderId?: string): string | undefined => {
  const casInvoiceApi = CasInvoiceApi.init();
  const { data, error } = useQuery(
    [QUERY_KEYS.invoiceUrl, orderId],
    async () => {
      if (!orderId) return;
      const decodedOrderId = atob(orderId);
      const invoiceUrl = await casInvoiceApi.getInvoicePdf(decodedOrderId);
      return invoiceUrl;
    },
    { enabled: orderId !== undefined }
  );

  if (error) {
    console.error(error);
    return;
  }

  return data?.url;
};
